import { renderToStaticMarkup } from 'react-dom/server';
import globalTranslations from './texts.json';
import commonTranslations from '../../youwell-common/translations.json';
// import { programLanguages } from '../../common/constants';

export const translations = { ...globalTranslations, ...commonTranslations };

const languageFromBrowser = () => {
    switch (window.navigator?.language?.toLowerCase()) {
    case 'nb-no':
    case 'nn-no':
    case 'nb':
    case 'nn':
    case 'no':
        return 'no';
    default:
        return 'en';
    }
};

const SessionLanguageKey = 'yw-lang';
const StorageProvider = window.sessionStorage; // window.localStorage;

const languageFromSession = () => {
    const lang = StorageProvider.getItem(SessionLanguageKey);
    return lang;
};

export const storeLanguagePreferance = (languageCode) => {
    StorageProvider.setItem(SessionLanguageKey, languageCode);
};

export const translateInitialization = defaultLanguage => ({
    languages: [
        { code: 'no', name: 'Norsk' },
        { code: 'en', name: 'English' }, // must include english here because it is present in language-files..
        { code: 'ua', name: 'Українська' },
        { code: 'ru', name: 'Pусский' },
    ],
    translation: translations,
    options: {
        renderToStaticMarkup,
        defaultLanguage: languageFromSession() || defaultLanguage || languageFromBrowser(),
        onMissingTranslation: obj => `missing translation for ${obj.translationId}`,
    },
});
